export default __webpack_public_path__ + "static/media/download.ba9defdb.svg";